import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import { Button } from "react-bootstrap";
import chatService from "../../services/chat.service";
import { expandIcon } from "../../utils/icons";
import { formatChicagoDateTime, formatTime } from "../../utils/dateFormat";
import FilesService from "../../services/files.service";
import ChatFiles from "./ChatFiles";
import { validateFiles, validateMessage } from "../../utils/validations";
import Error from "../../components/common/Error";
import PreviewFileModal from "../../components/common/Filemanager_PreviewFileModal";
import { downloadFile } from "../../utils/downloadFiles";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Editor } from '@tinymce/tinymce-react';



const ThreadDetails = ({
  threadId,
  UserId,
  fetchThreads,
  subject,
  hasTasks,
  setShowTasks,
  showTasks,
  message,
  fetchThreadMessage,
  client_id,
  clientName,
  loading,
  setLoading
}) => {

  const [files, setFiles] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [newMessage, setNewMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [uploading, setUploading] = useState(false);
  const [uploadIndex, setUploadIndex] = useState(0);
  const [selectedFileUrl, setSelectedFileUrl] = useState(null);
  const chatContainerRef = useRef(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);


  const [fileuploadError, setfileuploadError] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);


  const handleMessageChange = async (content) => {
    // const cleanedContent = content.replace(/<p><br><\/p>/g, '');
    const cleanedContent = content.replace(/(<p><br><\/p>)+$/g, "").trim();
    setNewMessage(cleanedContent);
  };


  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;

    // Validate the selected files
    const validationErrors = validateFiles(selectedFiles);

    if (validationErrors.length > 0) {
      setErrorMessage("One or more selected files are invalid.");
      return;
    }

    // If no validation errors, proceed with adding the files to the state
    setFiles([...files, ...selectedFiles]);
  };

  let fileDetailsArray = [];

  const saveFile = async (fileDetails) => {
    const data = {
      clientId: client_id,
      files: fileDetails,
    };

    try {
      var response = await FilesService.savefile(data);
      // uploadFilehandleClose()
    } catch (err) {
      //console.log(err);
    }

    return response;
  };

  const handleFileUpload = async (file, clientId) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("clientId", clientId);

    try {
      setUploading(true);

      const Filesdetails = await FilesService.UploadFiles(formData);

      fileDetailsArray.push({
        originalFileName: Filesdetails.originalFileName,
        uniqueFileName: Filesdetails.uniqueFileName,
        visibility: 1,
      });

      setUploadIndex((prevIndex) => prevIndex + 1);
      setUploading(false);
    } catch (error) {
      // console.error("Error uploading file:", error);
      setErrorMessage(error.response.data.errors[0].msg);
      setUploading(false);
    }
  };

  const sendMessage = async () => {
    try {
      if (files.length > 0 && !newMessage.trim()) {
        setErrorMessage("Message is required when sending files.");
        return;
      }
      setLoading(true);
      // dispatch(setMessage(messages.loading));

      if (uploadIndex < files.length && !uploading && !errorMessage) {
        for (let i = 0; i < files.length; i++) {
          await handleFileUpload(files[i], client_id);
        }
      }

      let fileIds = [];

      if (fileDetailsArray.length > 0) {
        var saveFiles = await saveFile(fileDetailsArray);

        fileIds = saveFiles.dbEntries.map((entry) => entry.id);
      }

      const data = {
        thread_id: threadId,
        messageBody: newMessage,
        files: fileIds.length > 0 ? fileIds : null,
        sendVia : { 'email': true}
      };

      await chatService.SendNewMessage(threadId, data);
      fetchThreadMessage(threadId);
      fetchThreads();
      setNewMessage("");
      setFiles([]);
      document.getElementById("attachFiles").value = "";
      setErrorMessage("");
    } catch (err) {
      //   console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // Handler for file preview modal
  const handleFilePreview = (file) => {
    setSelectedFile(file);
    setShowPreviewModal(true);
  };



  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
    setInitialLoading(false);
  }, [message]);



  return (
    <div className="thread">
      <div className="container-fluid">
        <div className="thread__header">
          <div>
            <span className="thread__subject">{subject}</span>
            {clientName && <span className="thread__client-name text-muted ms-2" style={{fontSize: '0.9rem'}}>({clientName})</span>}
          </div>
          
          {hasTasks && (
            <a
              onClick={() => setShowTasks(!showTasks)}
              className={`toggle-tasks ${showTasks ? "tasks-expanded" : "tasks-collapsed"
                }`}
            >
              <img src={expandIcon} width={24} />
            </a>
          )}
        </div>

        <div className="thread__chats">
          <div className="thread__chats__chats" ref={chatContainerRef}>
            {initialLoading
              ? Array.from({ length: 4 }).map((_, i) => {
                const isUser = i % 2 === 0;

                const alignStyle = isUser
                  ? {
                    alignSelf: "flex-start",
                    alignItems: "flex-start",
                    marginLeft: "1rem",
                    marginRight: "auto",
                  }
                  : {
                    alignSelf: "flex-end",
                    alignItems: "flex-end",
                    marginLeft: "auto",
                    marginRight: "3rem",
                  };

                return (
                  <div
                    key={i}
                    className={`message ${isUser ? "by-user" : "by-other"}`}
                    style={{
                      width: "300px",
                      display: "flex",
                      flexDirection: "column",
                      ...alignStyle,
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      className="message__header"
                      style={{ width: "100%" }}
                    >
                      <Skeleton
                        width={isUser ? "250px" : "250px"}
                        height={15}
                        style={{
                          marginBottom: "4px",
                          marginLeft: isUser ? "0" : "auto",
                        }}
                      />
                    </div>
                    <div
                      className="message__message"
                      style={{ width: "80%" }}
                    >
                      <Skeleton
                        width="100%"
                        height={15}
                        style={{
                          marginBottom: "4px",
                          marginLeft: isUser ? "0" : "auto",
                        }}
                      />
                      <Skeleton
                        width={isUser ? "80%" : "90%"}
                        height={15}
                        style={{
                          marginBottom: "4px",
                          marginLeft: isUser ? "0" : "auto",
                        }}
                      />
                    </div>
                  </div>
                );
              })
              : message &&
              message.map((msg) => (
                <div
                  key={msg.id}
                  className={`message ${msg.senderType === "clientportal_user" &&
                    msg.senderid == UserId
                    ? "by-user"
                    : "by-other"
                    }`}
                >
                  <div className="message__header">
                    <span className="message__sender">
                      {msg.senderType === "clientportal_user" &&
                        msg.senderid === UserId
                        ? "You"
                        : msg.senderName}
                    </span>
                    <span className="message__time">
                      {msg.message_time_date}
                    </span>
                  </div>
                  <div
                    className="message__message"
                    dangerouslySetInnerHTML={{ __html: msg.body }}
                  />
                  {msg.files && msg.files.length > 0 && (
                    <ChatFiles files={msg.files} showPreview={handleFilePreview} />
                  )}
                  {msg.images && msg.images.length > 0 && (
                    <div className="message__images d-flex flex-wrap gap-2 mt-2">
                      {msg.images.map((img, idx) => (
                        <img
                          key={img.key || idx}
                          src={img.url}
                          alt="attachment"
                          style={{
                            maxWidth: "150px",
                            maxHeight: "150px",
                            borderRadius: "6px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(img.url, "_blank")}
                        />
                      ))}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>

        <div className="thread__newmessage">
          <div style={{ width: '100%' }}>


            <Editor
              apiKey={process.env.REACT_APP_TINYMCE_KEY}
              value={newMessage}
              onEditorChange={(content) => setNewMessage(content)}
              init={{
                height: 180,
                menubar: false,
                branding: false,
                statusbar: false,
                placeholder: 'Type Message here...',
                plugins: 'lists',
                toolbar: 'bold italic underline | numlist bullist outdent indent',
                lists_indent_on_tab: true,
                indent_use_margin: true,

                setup: (editor) => {
                  editor.on('init', () => {
                    const style = document.createElement('style');

                    document.head.appendChild(style);
                  });
                },
              }}
            />

          </div>
          <div className="d-flex w-100 justify-content-between">
            <div
              className="input-group input-group-sm"
              style={{ maxWidth: "50%" }}
            >
              <input
                type="file"
                id="attachFiles"
                className="form-control form-control-primary"
                multiple
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,image/*"
                onChange={handleFileChange}
              />

            </div>

            {errorMessage && <Error error={errorMessage} />}

            <div>
              <Button
                variant="outline-primary"
                className="btn btn-sm"
                onClick={sendMessage}
                disabled={loading || !newMessage.trim()}
              >
                {loading ? "Sending..." : "Send"}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <PreviewFileModal
        show={showPreviewModal}
        handleClose={() => setShowPreviewModal(false)}
        file={selectedFile}
      />
    </div>
  );
};

export default ThreadDetails;